import { ScrollLockService } from '~/lib/services/scroll-lock-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useScrollLockService = defineServiceComposable('scroll-lock', () => new ScrollLockService())
